import { Link, router } from 'expo-router'
import { ChevronWithIcon, chevronStyles } from '@/src/common/components/ChevronWithIcon'
import { Tooltip } from '@/src/components/ui/panels/Tooltip'
import { Platform, StyleSheet, Text, View, ViewStyle } from 'react-native'
import { mobileAddInstallCtaUrl } from '@/src/app/main/(tabs)/card/cardBenefits'
import { ChevronRight } from '@/src/assets/icons/ChevronRight'
import { mesaColorNames, typography } from '@/src/common/theme'

export function ActivateCardButton({ style }: { style?: ViewStyle }) {
  return (
    <Tooltip
      content={
        Platform.OS === 'web' ? (
          <View
            style={{
              padding: 16,
              backgroundColor: mesaColorNames['Mesa - Brand/White #FFFFFF'],
              borderRadius: 12,
              borderWidth: 1,
              borderColor: mesaColorNames['Mesa Primary Scale/400 - Brand #00DFC9'],
            }}
          >
            <Text style={[chevronStyles.elementNameText, typography.S]}>
              Card activation is coming soon to web
            </Text>
          </View>
        ) : undefined
      }
      triggerProps={{ asChild: true }}
      arrowProps={{
        style: { backgroundColor: mesaColorNames['Mesa Primary Scale/400 - Brand #00DFC9'] },
      }}
    >
      <View style={{ ...styles.container, ...style }}>
        {Platform.OS === 'web' ? (
          <Link
            href={mobileAddInstallCtaUrl}
            style={{
              flex: 1,
              padding: 16,
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Text style={[chevronStyles.elementNameText, { flex: 1 }]}>
              Install the Mesa App to activate your card
            </Text>
            <ChevronRight {...chevronStyles.chevronRightIcon} />
          </Link>
        ) : (
          <ChevronWithIcon
            style={{
              paddingVertical: 16,
              paddingHorizontal: 16,
              flex: 1,
              borderRadius: 12,
              alignItems: 'center',
            }}
            segmentAction="Pressed Home Screen Card Delivery Module Activate Card Button"
            onPress={() => {
              router.push('/main/card/card-management')
              setTimeout(() => router.push('/main/card/card-management/virtual-card'), 222)
              setTimeout(
                () => router.push('/main/card/card-management/virtual-card/activateCard'),
                420,
              )
            }}
            textProps={{
              style: [
                typography['label/sm-bold'],
                { color: mesaColorNames['Primary/Brand #1C1C1C'] },
              ],
            }}
            text="Activate your Mesa Homeowners Card"
          />
        )}
      </View>
    </Tooltip>
  )
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: mesaColorNames['Mesa - Brand/White #FFFFFF'],
    borderRadius: 12,
    padding: 0,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderWidth: 1,
    borderColor: mesaColorNames['Mesa Primary Scale/400 - Brand #00DFC9'],
    overflow: 'hidden',
  },
})
